export const BASE_URL = '/';
let staticurl = '/assets/';
let siteurl = 'https://Querlo.test/';

console.log('------------->staging env.preact_app_staging', process.env.PREACT_APP_STAGING, 'env.node_env', process.env.NODE_ENV);
if (process.env.PREACT_APP_STAGING === 'stage') {
	staticurl = 'https://Querlo-assets-staging-cdn-endpoint.azureedge.net/public/assets/';
	siteurl = 'https://staging.Querlo.com/';
}
else if (process.env.NODE_ENV === 'production') {
	staticurl = 'https://static.Querlo.com/public/assets/';
	siteurl = 'https://www.Querlo.com/';
}
console.log('------>', staticurl, siteurl);
export const STATIC_BASE_URL = staticurl;
export const SITE_URL = siteurl;
